module.exports = __webpack_public_path__ + "img/FullCover_Eng5.8f14670e.jpg";